import { ActivitySurveyStatusData, CompanyInfo, ListedSurveyData } from "./pages/form/FormDataTypes";

const API_BASE = "http://185.7.62.58:5000";

async function FetchJson(url : string, options={})
{
    const result = await fetch(url, options);

    if (!result.ok) 
    {
        throw new Error(`API error: ${result.status}`);
    }
    return result.json();
} 

function toMySQLDateOnly(date: Date | string | null) {
  if (!date) return null;
  const d = new Date(date);
  // Convert to YYYY-MM-DD (drops the time)
  return d.toISOString().slice(0, 10);
}

export function UseAPICaller()
{
/// Company
    async function CheckLogin(companyName:string, password:string)
    {
        try 
        {
            const company = await FetchJson(`${API_BASE}/login`, {
                method:"POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({ companyName, password })
            });

            return company;
        } 
        catch (error) 
        {
            console.error(`Login failed: ${error}`);
            return false;
        }
    }

    async function AddNewCompany(companyName:string, password:string)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/companies`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    companyName:companyName,
                    password:password
                })
            });
        } 
        catch (error) 
        {
            console.log(`Could not add company. Msg: ${error}`);
        }
    }

    async function GetCompanyInfo(companyId: number)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/companies?companyId=${companyId}`);
        } 
        catch (error) 
        {
            console.log(`Could not fetch company info. Msg: ${error}`);
            return null;
        }
    }

    async function GetEditableCompanyInfo(companyId: number)
    {
        try 
        {
            const allInfo = await FetchJson(`${API_BASE}/companies?companyId=${companyId}`);
            return{
                doing:allInfo.doing as string,
                solving:allInfo.solving as string,
                target:allInfo.target as string,
                agendas:allInfo.agendas.map(a => a.id)
            };
        } 
        catch (error) 
        {
            console.log(`Could not fetch editable company info. Msg: ${error}`);
            return null;
        }
    }

    async function UpdateCompanyInfo(companyId: number, data: CompanyInfo)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/companies/${companyId}`, {
                    method: "PATCH",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(data)
                });
        } 
        catch (error) 
        {
            console.log(`Could not update company info. Msg: ${error}`);
            return null;
        }
    }

    async function UploadCompanyImage(companyId: number, file: File) 
    {
        try 
        {
            const formData = new FormData();
            formData.append('file', file);

            console.log(formData);

            const res = await fetch(`${API_BASE}/companies/${companyId}/image`, {
                method: 'POST',
                body: formData
            });

            if (!res.ok) throw new Error(`API error: ${res.status}`);

            return res.json();
        } 
        catch (error) 
        {
            console.log(`Could not upload company Image. Msg: ${error}`);
        }
    }

/// REPORTS
    async function GetReports(companyId: number)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/reports?companyId=${companyId}`);
        } 
        catch (error) 
        {
            console.log(`Could not fetch reports. Msg: ${error}`);
        }
    }

    async function CreateNewReport(companyId: number)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/reports`, {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({companyId:companyId})
                });
            
        } 
        catch (error) 
        {
            console.log(`Could not create a new activity. Msg: ${error}`);
        }
    }

    async function GetEditableReportInfo(reportId: number)
    {
        try 
        {
            const allInfo = await FetchJson(`${API_BASE}/reports/${reportId}`);

            return {
                title:allInfo.title as string, 
                startDate:allInfo.startDate as string, 
                endDate:allInfo.endDate as string, 
                description:allInfo.description as string, 
                surveys:allInfo.surveys.map(s => s.id),
                activities:allInfo.activities.map(a => a.id),
                agendas:allInfo.agendas.map(a => a.id),
                finished:allInfo.finished  as boolean,
                thumbnailPath:allInfo.thumbnailPath as string
            };    

        } 
        catch (error) 
        {
            console.log(`Could not fetch activity editable info. Msg: ${error}`);
            return null;
        }
    }

    async function UploadReportThumbnail(reportId: number, file: File)
    {
        try 
        {
            const formData = new FormData();
            formData.append('file', file);

            const res = await fetch(`${API_BASE}/reports/${reportId}/thumbnail`, {
                method: 'POST',
                body: formData
            });

            if (!res.ok) throw new Error(`API error: ${res.status}`);

            return res.json();
        } 
        catch (error) 
        {
            console.log(`Could not upload report thumbnail. Msg: ${error}`);
        }
    }

    async function UpdateReport(id:number, data)
        {
            try 
            {
                return await FetchJson(`${API_BASE}/reports/${id}`, {
                        method: "PATCH",
                        headers: {"Content-Type": "application/json"},
                        body: JSON.stringify(data)
                    });
            } 
            catch (error) 
            {
                console.log(`Could not update report. Msg: ${error}`);
                return null;
            }
        }

/// ACTIVITIES
    async function GetActivities(companyId: number)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/activities?companyId=${companyId}`);
        } 
        catch (error) 
        {
            console.log(`Could not fetch activites. Msg: ${error}`);
        }
    }

    async function CreateNewActivity(companyId: number)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/activities`, {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({companyId:companyId})
                });
            
        } 
        catch (error) 
        {
            console.log(`Could not create a new activity. Msg: ${error}`);
        }
    }

    async function GetEditableActivityInfo(activityId: number)
    {
        try 
        {
            const allInfo =  await FetchJson(`${API_BASE}/activities/${activityId}`);

            return{
                title:allInfo.title as string,
                type:allInfo.type as string,
                startDate:allInfo.startDate as string,
                endDate:allInfo.endDate as string,
                description:allInfo.description as string,
                attendees:allInfo.attendees as number,
                finished:allInfo.finished as boolean,
                thumbnailPath:allInfo.thumbnailPath as string,
                agendas:allInfo.agendas.map(a => a.id),
                surveys:allInfo.surveys.map(s => s.id)
            };
        } 
        catch (error) 
        {
            console.log(`Could not fetch activity editable info. Msg: ${error}`);
            return null;
        }
    }

    async function UpdateActivity(activityId: number, data)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/activities/${activityId}`, {
                    method: "PATCH",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(data)
                });
        } 
        catch (error) 
        {
            console.log(`Could not update surveys info. Msg: ${error}`);
            return null;
        }
    }

    async function UploadActivityThumbnail(activityId: number, file: File)
    {
        try 
        {
            const formData = new FormData();
            formData.append('file', file);

            const res = await fetch(`${API_BASE}/activities/${activityId}/thumbnail`, {
                method: 'POST',
                body: formData
            });

            if (!res.ok) throw new Error(`API error: ${res.status}`);

            return res.json();
        } 
        catch (error) 
        {
            console.log(`Could not upload activity thumbnail. Msg: ${error}`);
        }
    }


/// SURVEYS
    async function GetSurveys(companyId: number)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/surveys?companyId=${companyId}`);

        } 
        catch (error) 
        {
            console.log(`Could not fetch surveys. Msg: ${error}`);
        }
    }
    async function GetSurvey(companyId: number)
    {
        try 
        {
            const survey = await FetchJson(`${API_BASE}/surveys/${companyId}`);
            return survey;
        } 
        catch (error) 
        {
            console.log(`Could not fetch surveys. Msg: ${error}`);
        }
    }
    async function GetSurveysList(companyId: number)
        {
            try 
            {
                const surveys = await GetSurveys(companyId);
    
                let payload :ListedSurveyData[] = [];
    
                surveys.forEach(element => {
                    payload.push({
                        id:element.id,
                        title:element.title
                    } as ListedSurveyData);
                });
    
                return payload;
            } 
            catch (error) 
            {
                console.log(`Could not fetch surveys. Msg: ${error}`);
            }
    }

    async function CreateNewSurvey(title:string, companyId:number)
    {
      try 
        {
            const response:FormData =  await FetchJson(`${API_BASE}/surveys`, {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({companyId:companyId, title:title})
                });
            
            return response
        } 
        catch (error) 
        {
            console.log(`Could not create a new survey. Msg: ${error}`);
        }
    }

    async function UpdateSurvey(id: number, data)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/surveys/${id}`, {
                    method: "PATCH",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(data)
                });
        } 
        catch (error) 
        {
            console.log(`Could not update surveys info. Msg: ${error}`);
            return null;
        }
    }
    async function PublishSurvey(surveyId:number)
    {
        try 
        {
            const link = `/survey/${surveyId}`;
            return UpdateSurvey(surveyId, {active:true, published:true, link});
        } 
        catch (error) 
        {
            console.log(`Could not activate survey. Msg: ${error}`);
            return null;
        }
    }

    async function GetSurveyViewInfo(surveyId:number)
    {
        try 
        {
            const response = await GetSurvey(surveyId);

            return {
                title: response.title || "",
                link: response.link || "",
                active: response.active || false,
                numResponses: response.numResponses || 0,
            }; 
        } 
        catch (error) 
        {
            console.log(`Could not fetch survey. Msg: ${error}`);
            return null;
        }
    }

    async function DeactivateSurvey(surveyId:string)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/surveys/${surveyId}`, {
                    method: "PATCH",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({active:false})
                });
        } 
        catch (error) 
        {
            console.log(`Could not deactivate survey. Msg: ${error}`);
            return null;
        }
    }

/// RESPONSES
    async function GetResponses(surveyId:number)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/responses?surveyId=${surveyId}`);
        } 
        catch (error) 
        {
            console.log(`Could not fetch responses. Msg: ${error}`);
            return null;
        }
    }
    // payload = {surveyId, answers}
    async function StoreResponses(payload)
    {
        try 
        {
            console.log(payload);
            return await FetchJson(`${API_BASE}/responses`, {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(payload)
                });
        } 
        catch (error) 
        {
            console.log(`Could not store responses. Msg: ${error}`);
            return null;
        }
    }

/// MISC
    async function DeleteResource(resource: string, id: number) 
    {
        try 
        {
            const response = await fetch(`${API_BASE}/${resource}/${id}`, { 
                method: "DELETE",
                headers: { "Content-Type": "application/json" }
            });

            if (!response.ok) 
            {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            return true;
        } 
        catch (err) 
        {
            console.error(err);
            return false;
        }
    }

    async function GetActivitySurveyStatus(companyId:number)
    {
        try 
        {
            const activities = await FetchJson(`${API_BASE}/activities?companyId=${companyId}`);
            if (!activities) 
            {
                throw new Error("Could not get activities.");
            }

            const surveys = await FetchJson(`${API_BASE}/surveys?companyId=${companyId}`);
            if (!surveys) 
            {
                throw new Error("Could not get reoprts.");
            }

            let oa = activities.filter(item => item.finished ===  0).length;
            let fa = activities.length - oa;
            let os = surveys.filter(item => item.published ===  0).length;
            let ps = surveys.length - os;

            let payload:ActivitySurveyStatusData = {
                openSurveys:os,
                openActivities:oa,
                publishedSurveys:ps,
                finishedActivities:fa
            };

            return payload;
        } 
        catch (error) 
        {
            console.log(`Could not fetch report/activity status. Msg: ${error}`);
            return null;
        }
    }

    async function GetSummaryData()
    {
        // try 
        // {
        //     return await FetchJson(`${API_BASE}/responses?surveyId=${surveyId}`);
        // } 
        // catch (error) 
        // {
        //     console.log(`Could not fetch responses. Msg: ${error}`);
        //     return null;
        // }
    }

    async function GenerateSummary(companyId:number, activities:number[], surveys:number[], wordCount:number)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/reportsummary`, {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({companyId:companyId, activities:activities, surveys:surveys, wordCount:wordCount})
                });
        } 
        catch (error) 
        {
            console.log(`Could not generate summary. Msg: ${error}`);
            return null;
        }
    }

    return {
        CheckLogin,
        AddNewCompany,
        GetCompanyInfo,
        GetEditableCompanyInfo,
        UpdateCompanyInfo,
        UploadCompanyImage,

        GetReports,
        CreateNewReport,
        GetEditableReportInfo,
        UploadReportThumbnail,
        UpdateReport,

        GetActivities,
        CreateNewActivity,
        GetEditableActivityInfo,
        UpdateActivity,
        UploadActivityThumbnail,

        GetSurveys,
        GetSurvey,
        CreateNewSurvey,
        UpdateSurvey,
        PublishSurvey,
        GetSurveyViewInfo,
        DeactivateSurvey,

        GetResponses,
        StoreResponses,

        DeleteResource,
        GetActivitySurveyStatus,
        GetSummaryData,
        GenerateSummary
    }
}